<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>内容管理</a-breadcrumb-item>
    <a-breadcrumb-item>微小变形方式设置</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <div style="flex: 1;"></div>
    <!-- 新建设置按钮 -->
    <a-button type="primary" @click="touchAdd"><plus-outlined />新建设置</a-button>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 设置时间 -->
      <template v-if="column.key === 'set_time'">
        {{ record.set_time }}
      </template>
      <!-- 剧目ID -->
      <template v-if="column.key === 'wechat_drama_ids'">
        {{ formatDramaIds(record.wechat_drama_ids) }}
      </template>
      <!-- 变现类型 -->
      <template v-if="column.key === 'wx_type'">
        {{ getWxTypeText(record.wx_type) }}
      </template>
      <!-- 存在会员 -->
      <template v-if="column.key === 'wx_vip'">
        {{ record.wx_vip === 1 ? '是' : '否' }}
      </template>
      <!-- 操作人 -->
      <template v-if="column.key === 'create_username'">
        {{ record.create_username }}
      </template>
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
        <!-- 操作项预留 -->
      </template>
    </template>
  </a-table>
  <!-- 新建设置弹窗 -->
  <AddWxTypeModal ref="RefAddWxTypeModal" @success="getData" />
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { PlusOutlined } from '@ant-design/icons-vue'
import { projectWxList } from '@/api/operate'
import { WXProfitTypes } from '@/utils/constantList'
import AddWxTypeModal from './components/AddWxTypeModal.vue'

// 新建设置弹窗组件实例
let RefAddWxTypeModal = ref(null)
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showTotal: (total) => `总共${total}条`
})
// 列数据源
let columns = ref([
  {
    title: '设置时间',
    dataIndex: 'set_time',
    key: 'set_time'
  },
  {
    title: '剧目ID',
    dataIndex: 'wechat_drama_ids',
    key: 'wechat_drama_ids'
  },
  {
    title: '变现类型',
    dataIndex: 'wx_type',
    key: 'wx_type'
  },
  {
    title: '存在会员',
    dataIndex: 'wx_vip',
    key: 'wx_vip'
  },
  {
    title: '操作人',
    dataIndex: 'create_username',
    key: 'create_username'
  }
])

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  getData()
})

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getData()
}

// 获取数据
function getData () {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize
  }
  projectWxList(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.data || []
      pagination.total = data.total || 0
    } else {
      message.error(res.message || msg)
    }
  }).catch(err => {
    isLoading.value = false
    message.error('获取数据失败')
    console.error(err)
  })
}

// 格式化剧目ID数组为字符串
function formatDramaIds (ids) {
  if (!ids || !Array.isArray(ids)) {
    return '-'
  }
  return ids.join('; ')
}

// 获取变现类型文本
function getWxTypeText (type) {
  const item = WXProfitTypes.find(item => item.value === type)
  return item ? item.text : '-'
}

// 新建设置
function touchAdd () {
  RefAddWxTypeModal.value.showModal()
}

</script>

<style scoped>
.tool-view {
  display: flex;
  align-items: center;
  margin-top: 30px;
}
.table-view {
  margin-top: 30px;
}
</style>

